import React from "react";

const Footer = ()=> {
    return  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h5>Together, we can unlock the full potential of AI and drive positive change in our society.</h5>
          <h3>WEZA LAB</h3>
          <ul class="contact-nav">
            <li><a data-scroll href="#home">Home</a></li>
            <li><a data-scroll href="#about-us">About Us</a></li>
            <li><a data-scroll href="#projects">Projects</a></li>
            <li><a data-scroll href="#blog">Blog</a></li>
            <li><a data-scroll href="#contact-us">Contact</a></li>
          </ul>
          <h6>© 2023 - Weza laboratory SARLU, All Right Reserved</h6>
          <ul class="social">
            <li><a href="https://www.facebook.com/wezalab"><i class="icofont-facebook"></i></a></li>
            <li><a href="https://twitter.com/wezalab"><i class="icofont-twitter"></i></a></li>
            <li><a href="https://www.linkedin.com/company/wezalab/"><i class="icofont-linkedin"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
}

export default Footer;
